<template>
    <div>
        <transition name="fade">
            <Row v-if="mainTable.sarchCardShow"
                :gutter="16">
                <Col span="24">
                <search-card :form="mainTable.searchForm"
                    :table-load-event="getMainTableRecords"
                    :table-search="mainTable.tableSearch" />
                </Col>
            </Row>
        </transition>

        <Card>
            <Row :gutter="16">
                <Col span="24">
                <div class="global-tool-bar">
                    <div class="left-bar">
                        <span class="title">质检不合格通知书</span>
                    </div>
                    <div class="right-bar">
                        <Button type="primary"
                            size="small"
                            class="btns"
                            shape="circle"
                            icon="ios-search"
                            @click="mainTable.sarchCardShow = !mainTable.sarchCardShow">搜索</Button>
                    </div>
                </div>
                </Col>
            </Row>

            <Row :gutter="16">
                <Col span="24">
                <stand-pagination-table :columns="mainTable.tableColumns"
                    :data="mainTable.tableData"
                    :loading="mainTable.tableLoading"
                    :table-search="mainTable.tableSearch"
                    :table-load-event="getMainTableRecords" />
                </Col>
            </Row>
        </Card>

        <QualifyFailReportDetail ref="qualifyFailReportDetailModal" />
    </div>
</template>

<script>
import SearchCard from '@/components/searchCard/searchCard.vue';
import StandPaginationTable from '@/components/standard-pagination-table/StandPaginationTable';
import search from '@/libs/search';
import { dateRender } from '@/libs/tableRowTimeRender';
import QualifyFailReportDetail from './qualifyFail-report-detail';
import { getQualifyFailReportRecord } from '@/api/modules/qualifyFail-report-management/qualifyFail-report';

export default {
    name: 'QualifyFailReportList',
    components: {
        StandPaginationTable,
        SearchCard,
        QualifyFailReportDetail
    },
    data() {
        return {
            mainTable: {
                tableColumns: [
                    { title: '类型', key: 'qualifyFailReportRecordType', align: 'center' },
                    { title: '质检转运站', key: 'distributionStationName', align: 'center' },
                    { title: '发货苗场', key: 'seedFarmName', align: 'center' },
                    { title: '苗场回复', key: 'qualifyFailReportRecordSeedFarmResponse', align: 'center' },
                    { title: '专家', key: 'masterName', align: 'center' },
                    { title: '专家回复', key: 'qualifyFailReportRecordMasterResponse', align: 'center' },
                    { title: '日期', key: 'qualifyFailReportRecordCreateAt', align: 'center', render: (h, params) => dateRender(h, params.row.qualifyFailReportRecordCreateAt) },
                    {
                        title: '操作',
                        key: 'action',
                        align: 'center',
                        width: 80,
                        render: (h, params) => {
                            return h('div', [
                                h('Button', {
                                    props: {
                                        type: 'text',
                                        size: 'small',
                                        shape: 'circle'
                                    },
                                    on: {
                                        click: () => {
                                            this.$refs.qualifyFailReportDetailModal.showModal(params.row.qualifyFailReportRecordUuid);
                                        }
                                    }
                                }, '查看')
                            ]);
                        }
                    }
                ],
                tableData: [],
                tableLoading: false,
                tableSearch: search.getSearchParams(),
                sarchCardShow: false,
                searchForm: [
                    { label: '转运站', type: 'Input', value: '', name: 'distributionStationName', sql: 'like' },
                    { label: '苗场', type: 'Input', value: '', name: 'seedFarmName', sql: 'like' },
                    { label: '日期', type: 'Daterange', value: '', name: 'qualifyFailReportRecordCreateAt', sql: 'dateBetween' }
                ]
            }
        };
    },
    mounted() {
        this.init();
    },
    methods: {
        init() {
            this.getMainTableRecords();
        },
        getMainTableRecords(reset = false) {
            this.mainTable.tableLoading = true;

            if (reset) {
                search.globalResetSearch(this.mainTable.tableSearch);
            }
            getQualifyFailReportRecord(this.mainTable.tableSearch).then(res => {
                if (res.code === 0) {
                    this.mainTable.tableData = res.data.records;
                    search.globalSetFilterRecordCount(this.mainTable.tableSearch, res.data.filterRecordCount);
                }

                this.mainTable.tableLoading = false;
            });
        }
    }
};
</script>

<style scoped>
</style>
